import React, { useEffect, useState } from 'react';
import { STORAGE_KEYS } from 'utils/constants';
import { FileUploader, ToastMessage } from '@cokitchen/cokitchen-components';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router-dom';
import useEditShopContext from 'contexts/shop.context';

type Props = {
  onEditComplete: () => void;
};
const EditShopImages = ({ onEditComplete }: Props) => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const { shopDetails, setShopDetails, setDisabled } = useEditShopContext();
  const [loading, setLoading] = useState(false);

  const { shop_id } = useParams();

  const handleUpdateShop = async () => {
    setLoading(true);
    const payload = {
      ...(shopDetails.logo?.trim() !== '' && { logo: shopDetails.logo }),
      ...(shopDetails.images.length && { images: [...shopDetails.images] })
    };
    try {
      await apiService.put(`shops/${shop_id}`, { data: payload });

      onEditComplete();
      toast(<ToastMessage type='success' message={`Shop updated successfully`} />);
    } catch {
      toast(<ToastMessage type='error' message={`There was a problem updating shop `} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const { images = [], logo = '' } = shopDetails;
    setDisabled(images?.length === 0 || !logo);
  }, [shopDetails]);

  return (
    <div>
      <div className='mb-8'>
        <FileUploader
          token={token}
          fileUrls={shopDetails?.images}
          label={<h3 className='font-medium mb-2'>Add shop image </h3>}
          setFileUrls={(k) => setShopDetails({ ...shopDetails, images: k })}
        />
      </div>
      <div>
        <FileUploader
          token={token}
          fileUrls={shopDetails.logo ? [shopDetails.logo] : []}
          label={<h3 className='font-medium mb-2'>Add shop logo </h3>}
          setFileUrls={(k) => setShopDetails({ ...shopDetails, logo: k[0] })}
        />
      </div>
      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateShop}
        backBtndisabled
        btnDisabled={loading}
      />
    </div>
  );
};

export default EditShopImages;
